import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { audiences } from "@/mocks/site";

export default function AudienceSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="İki farklı ihtiyaç, tek doğru merkez"
            title="Hasta mısınız, diş hekimi mi?"
            description="İster diş hekiminiz sizi yönlendirmiş olsun, ister kliniğiniz için güvenilir bir görüntüleme partneri arıyor olun — süreç her iki taraf için de net."
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {audiences.map((audience, index) => {
            const isDark = audience.cta.tone === "secondary";
            return (
              <Reveal key={audience.title} delay={index * 90}>
                <article
                  className={`flex h-full flex-col rounded-lg border p-7 md:p-9 ${
                    isDark
                      ? "border-primary-900 bg-primary-950"
                      : "border-background-300 bg-background-100"
                  }`}
                >
                  <span
                    className={`inline-flex w-fit items-center rounded-full px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.16em] ${
                      isDark
                        ? "bg-accent-500 text-foreground-950"
                        : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    {audience.badge}
                  </span>

                  <h3
                    className={`mt-6 font-heading text-2xl font-medium tracking-tight md:text-3xl ${
                      isDark ? "text-background-50" : "text-foreground-950"
                    }`}
                  >
                    {audience.title}
                  </h3>

                  <p
                    className={`mt-4 text-sm leading-relaxed md:text-[15px] ${
                      isDark ? "text-background-200/85" : "text-foreground-600"
                    }`}
                  >
                    {audience.text}
                  </p>

                  <ul className="mt-7 flex flex-1 flex-col gap-3.5">
                    {audience.points.map((point) => (
                      <li key={point} className="flex items-start gap-3">
                        <i
                          className={`ri-check-line mt-0.5 text-base ${
                            isDark ? "text-accent-400" : "text-primary-600"
                          }`}
                          aria-hidden="true"
                        />
                        <span
                          className={`text-sm ${
                            isDark ? "text-background-200/90" : "text-foreground-700"
                          }`}
                        >
                          {point}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <Link
                    to={audience.cta.href}
                    className={`mt-8 inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-semibold transition-colors ${
                      isDark
                        ? "bg-accent-500 text-foreground-950 hover:bg-accent-400"
                        : "bg-primary-500 text-background-50 hover:bg-primary-600"
                    }`}
                  >
                    {audience.cta.label}
                    <i className="ri-arrow-right-line text-base" aria-hidden="true" />
                  </Link>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}